import { allThePolyFills } from "./polyfill/polyfill";

// Web Components
// TODO: Only load for pages that actually use this component
import { LazyLoadImages } from "./components/lazy-image/lazy-image";
import { NavigationComponent } from "./components/navigation/navigation.component";

void async function main() {

    try {

        // tslint:disable-next-line:no-console
        console.log("Polyfilling...");

        await allThePolyFills();

        // tslint:disable-next-line:no-console
        console.log("LazyLoadImages.init()...");

        await LazyLoadImages.init();

        const autoInitComponents = [
            NavigationComponent,
        ];

        autoInitComponents.map((component) =>
            component.autoInit(),
        );

        const promiseComponents = [] as Array<Promise<any>>;

        // Main content (outside of standard template content)
        const page = document.querySelector("main") as HTMLElement;

        if (window.location.pathname === "/") {
            // Import "socials wall"
            promiseComponents.push(import("./components/socials/socials.component"));
        }

        if (page.querySelector("form") instanceof HTMLFormElement) {
            // Import input components
            promiseComponents.push(import("./components/form/form.component"));
        }

        if (page.querySelector(".panel-selectors") instanceof HTMLElement) {
            // Import panel component
            promiseComponents.push(import("./components/panel/panel.component"));
        }

        if (page.querySelector(".accordion") instanceof HTMLElement) {
            // Import accordion component
            promiseComponents.push(import("./components/accordion/accordion.component"));
        }

        if (page.querySelector(".slider") instanceof HTMLElement) {
            // Import slider component
            promiseComponents.push(import("./components/slider/slider.component"));
        }

        if (page.querySelector(".article-slider") instanceof HTMLElement) {
            // Import slider component
            promiseComponents.push(import("./components/slider/article-slider.component"));
        }

        if (page.querySelector(".slider--fullscreen") instanceof HTMLElement) {
            // Import fullscreen slider component
            promiseComponents.push(import("./components/slider/slider-fullscreen.component"));
        }

        if (page.querySelector(".modal") instanceof HTMLElement) {
            // Import modal component
            promiseComponents.push(import("./components/modal/modal.component"));
        }

        if (page.querySelector(".modal--slider") instanceof HTMLElement) {
            // Import slider modal component
            promiseComponents.push(import("./components/modal/slider-modal.component"));
        }

        if (page.querySelector(".modal--video") instanceof HTMLElement) {
            // Import video modal component
            promiseComponents.push(import("./components/modal/video-modal.component"));
        }

        if (page.querySelector(".filter[data-filter=\"select\"]") instanceof HTMLElement) {
            // Import filter component
            promiseComponents.push(import("./components/filter/filter.component"));
        }

        if (page.querySelector(".filter[data-filter=\"calendar\"]") instanceof HTMLElement) {
            // Import filter component
            promiseComponents.push(import("./components/filter/filter-calendar.component"));
        }

        if (page.querySelector(".filter[data-filter=\"search\"]") instanceof HTMLElement) {
            // Import filter component
            promiseComponents.push(import("./components/filter/filter-search.component"));
        }

        if (page.querySelector("[data-loader]") instanceof HTMLElement) {
            // Import loader component
            promiseComponents.push(import("./components/loader/loader.component"));
        }

        if (document.querySelector(".back-button") instanceof HTMLAnchorElement) {
            // Import loader component
            promiseComponents.push(import("./components/back-button/back-button.component"));
        }

        if (document.querySelector("[data-save-cookie-settings]") instanceof HTMLButtonElement) {
            // Import cookie settings component
            promiseComponents.push(import("./components/cookie-settings/cookie-settings.component"));
        }

        if (document.querySelector("[data-copy-to-clipboard]") instanceof HTMLAnchorElement) {
            // Import clipboard component
            promiseComponents.push(import("./components/clipboard/clipboard.component"));
        }

        // Load and run all needed components
        Promise.all(promiseComponents).then((values: any[]) => {
            for (const value of values) {
                const component = value[Object.keys(value)[0]];
                component.autoInit();
            }
        }).catch((error) => {
            throw new Error(error);
        });

        // Javascript import
        await Promise.all([
            import("./javascript/navigation-mobile-device" as any),
            import("./javascript/horizontal-scroll-navigation" as any),
        ]);

    } catch (exception) {
        // tslint:disable-next-line:no-console
        console.error(exception);
    }

    (window as any).DOMIsChanged = () => {
        const event = new CustomEvent("DOMChanged");
        document.dispatchEvent(event);
    };
}();



// WEBPACK FOOTER //
// ./web.ts